import React from 'react';
import { Col } from 'react-grid-system';
import Section from '../Section';
import Hero from '../Hero';

function HeroSection(props) {
  return (
    <Section size="small" fullBleed>
      <Col>
        <Hero {...props} />
      </Col>
    </Section>
  );
}

export default HeroSection;
